export const ON_CHANGE_HELP_CONTACT = 'ON_CHANGE_HELP_CONTACT'
export const ON_RESET = 'ON_RESET'